/**
 * @generated SignedSource<<de2d5420966eaebbe0bce1d9450c6fcb>>
 * @relayHash 03141bab41f294dbd4ef110b0dfd3b82
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5039e3f7d11f191ab3ef74dcfd79d3bee6023ac2a82df19346a5cafaaa3b25bf

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GlobalSpaceQuery$variables = {
  cloudId: string;
};
export type GlobalSpaceQuery$data = {
  readonly confluence_questionsConfiguration: {
    readonly confluenceQuestionsGlobalSpaceId: string | null | undefined;
    readonly confluenceQuestionsGlobalSpaceKey: string | null | undefined;
    readonly hasConfluenceQuestionsAccess: boolean | null | undefined;
    readonly isConfluenceQuestionsInstalled: boolean | null | undefined;
  } | null | undefined;
};
export type GlobalSpaceQuery = {
  response: GlobalSpaceQuery$data;
  variables: GlobalSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceQuestionsConfiguration",
    "kind": "LinkedField",
    "name": "confluence_questionsConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "confluenceQuestionsGlobalSpaceKey"
      },
      {
        "kind": "ScalarField",
        "name": "hasConfluenceQuestionsAccess"
      },
      {
        "kind": "ScalarField",
        "name": "confluenceQuestionsGlobalSpaceId"
      },
      {
        "kind": "ScalarField",
        "name": "isConfluenceQuestionsInstalled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalSpaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalSpaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "03141bab41f294dbd4ef110b0dfd3b82",
    "id": "5039e3f7d11f191ab3ef74dcfd79d3bee6023ac2a82df19346a5cafaaa3b25bf",
    "metadata": {},
    "name": "GlobalSpaceQuery",
    "operationKind": "query",
    "text": "query GlobalSpaceQuery($cloudId:ID!){confluence_questionsConfiguration(cloudId:$cloudId){confluenceQuestionsGlobalSpaceKey,hasConfluenceQuestionsAccess,confluenceQuestionsGlobalSpaceId,isConfluenceQuestionsInstalled}}"
  }
};
})();

(node as any).hash = "be64fbb1a28b54db1d9b6f0a24cf36d5";

export default node;
